const resource = {
    resource_identifier_in_use: 'Identyfikator API {{indicator}} jest już używany',
};
export default Object.freeze(resource);
